import { metaAccount } from '@/router/meta-config'
const permissionKey = 'PAGE'

export default [
  {
    path: '/legal-details',
    name: 'page-legal-details',
    component: () => import('@/pages/legal-details'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/legal-detail/:id',
    name: 'page-legal-detail',
    component: () => import('@/pages/legal-detail'),
    props: (route) => ({ id: Number(route.params.id) }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
